<!--
  Layout for public (guest) pages: landing page header on top, landing page footer at the bottom.
  Usage (App.vue):   <PublicLayout><router-view /></PublicLayout>
  A route opts in with   meta: { publicLayout: true }
-->
<template>
  <div class="public-layout">
    <LandingHeader />
    <main class="public-layout-main">
      <slot />
    </main>
    <LandingFooter />
  </div>
</template>

<script>
import LandingHeader from "@/login/Landing Page Header/landing_page_header.vue";
import LandingFooter from "./LandingFooter.vue";

export default {
  name: "PublicLayout",
  components: { LandingHeader, LandingFooter },
};
</script>

<style scoped>
.public-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  /* same background as the landing page */
  background: linear-gradient(66deg, rgba(183, 233, 247, 1) 25%, rgba(255, 255, 255, 1) 100%);
}

/* the landing header is position: fixed, so push the content below it */
.public-layout-main {
  flex: 1;
  width: 100%;
  padding-top: 10px;
}
</style>
